import { style } from 'typestyle'
export const mb4 = style({ marginBottom: '4px' })
